document.addEventListener("DOMContentLoaded", function () {
  let product = new Swiper(".reward-product-section .swiper-container", {
    grid: {
      fill: "row",
      rows: 2,
    },
    slidesPerView: 2,
    spaceBetween: 10,
    observer: true,
    resizeObserver: true,
    pagination: {
      el: ".reward-product-section .reward-pagination",
      clickable: true,
    },
    breakpoints: {
      1000: {
        slidesPerView: 4,
        spaceBetween: 20,
        navigation: {
          nextEl: ".reward-product-section .reward-arrow-next",
          prevEl: ".reward-product-section .reward-arrow-prev",
        },
        grid:false
      },
    },
  });

  // reward product section点击每个item的rules出现弹窗
  $(".reward-product-section .rules-link").click(function () {
    let link_index = $(this).data("index");
    $(".reward-product-section .rules-notice-bg").addClass("active");
    $(".reward-product-section .rules-notice-bg .rules-notice-box").removeClass(
      "active"
    );
    $(
      `.reward-product-section .rules-notice-bg .rules-notice-box[data-index=${link_index}]`
    ).addClass("active");
  });

  $(".reward-product-section .rules-close-btn,.rules-notice-bg").click(
    function () {
      $(".reward-product-section .rules-notice-bg").removeClass("active");
      $(
        ".reward-product-section .rules-notice-bg .rules-notice-box"
      ).removeClass("active");
    }
  );

  function sameHeight(selector) {
    let maxheight = 0;
    $(selector).each(function () {
      if (maxheight < $(this).height()) maxheight = $(this).height();
    });
    $(selector).css({ height: maxheight + 'px' });
  }

  // item 统一高度
  sameHeight(".reward-product-section .reward-coupon-product-box");
  $(window).resize(function () {
    sameHeight(".reward-product-section .reward-coupon-product-box");
  });
});
